import { z } from "zod";

export const qrTokenKindSchema = z.enum(["feedback", "google_review"]);
export type QrTokenKind = z.infer<typeof qrTokenKindSchema>;

export const generateQrBatchSchema = z.object({
  terminId: z.string().uuid("Neplatné ID termínu"),
  kind: qrTokenKindSchema,
});

export const getByTokenSchema = z.object({
  token: z.string().min(10).max(64),
});

export const submitQrFeedbackSchema = z.object({
  token: z.string().min(10).max(64),
  rating: z.coerce.number().int().min(1).max(5),
  komentar: z.string().max(5000, "Komentář musí být 5000 znaků nebo méně").optional(),
});

export const trackGoogleReviewClickSchema = z.object({
  token: z.string().min(10).max(64),
});

export type GenerateQrBatchInput = z.infer<typeof generateQrBatchSchema>;
export type SubmitQrFeedbackInput = z.infer<typeof submitQrFeedbackSchema>;
export type TrackGoogleReviewClickInput = z.infer<typeof trackGoogleReviewClickSchema>;
